import React from "react";
import {
  Box,
  ButtonGroup,
  Container,
  HStack,
  Text,
  Button,
  Icon,
} from "@chakra-ui/react";
import PropTypes from "prop-types";
import { Link as RouterLink } from "react-router-dom";
import { IoArrowBack } from "react-icons/io5";

const BackButton = () => {
  return (
    <Box
      bg="white"
      position="relative"
      style={{
        boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.11)',
        zIndex: 99,
      }}
      zIndex="docked"
    >
      <Container
        display="flex"
        alignItems="center"
        justifyContent="flex-start"
      >
        <Icon
          py={2}
          px={2}
          as={IoArrowBack}
          boxSize={10}
          cursor="pointer"
          onClick={() => window.history.back()}
          color="gray.600"
        />
      </Container>
    </Box>
  );
};

BackButton.propTypes = {
  // links: PropTypes.array,
};

BackButton.defaultProps = {
  // links: [],
};

export { BackButton };
